import React from "react";
import { VariationRow } from "./VariationRow";

export function VariationsPlayer({
  variations,
  playingVariationId,
  isPlaying,
  currentTime,
  duration,
  volume,
  onPlayVariation,
  onSeek,
  onVolumeChange,
  isSupportUser,
  togglingVariation,
  onToggleVariation,
}) {
  if (!variations || variations.length === 0) {
    return (
      <div style={{ textAlign:"center", padding:"12px 0", fontSize:12, color:"#7b7b7b" }}>
        No audio variations yet — the backend job will generate them shortly.
      </div>
    );
  }

  return (
    <div>
      <div style={{ display:"flex", flexDirection:"column" }}>
        {variations.map((v, i) => (
          <div key={v.variation_id} style={{ borderTop: i > 0 ? "1px solid #E2E2E2" : "none" }}>
            <VariationRow
              variation={v}
              isCurrentTrack={playingVariationId === v.variation_id}
              isPlaying={isPlaying}
              currentTime={playingVariationId === v.variation_id ? currentTime : 0}
              duration={playingVariationId === v.variation_id ? duration : 0}
              onPlay={() => onPlayVariation(v)}
              onSeek={onSeek}
              isSupportUser={isSupportUser}
              isToggling={togglingVariation.has(v.variation_id)}
              onToggle={(e) => onToggleVariation(e, v)}
            />
          </div>
        ))}
      </div>

      <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:8 }}>
        <span style={{ fontSize:12, color:"#7b7b7b" }}>🔊</span>
        <input
          type="range"
          min={0}
          max={1}
          step={0.05}
          value={volume}
          onChange={e => onVolumeChange(Number(e.target.value))}
          style={{ width:72, accentColor:"#F90091", cursor:"pointer" }}
        />
      </div>
    </div>
  );
}
